import React, { useState } from "react";
import { useSelector } from "react-redux";
import RejectionReasonsTable from "../Card/MaterEntryCards/RejectionReasonsTable";
import RejectionReasonsCard from "../Card/MaterEntryCards/RejectionReasonsCard";
import CardHeadMenu from "../Card/CardHeadMenu/CardHeadMenu";

//FUNCTION
const RejectionReasons = () => {
    //#region code
    const { is_super, is_admin } = useSelector((state) => state.GlobalVariables);
    const [isChanged, setIsChanged] = useState(false);
    const [editData, setEditData] = useState({});
    const [isCreate, setIsCreate] = useState(false);
    const [isEdit, setIsEdit] = useState(false);

    const handleEdit = (data) => {
        setEditData(data);
        setIsCreate(true);
        setIsEdit(true);
    };

    const handlePopup = () => {
        setIsCreate(!isCreate);
    };
    //#endregion

    return (
        <>
            <CardHeadMenu
                prefix={"Na"}
                suffix={"Na"}
                title={"REJECTION REASONS"}
                handlePopup={handlePopup}
                isEdit={isEdit}
                create={isCreate}
                showCreate={Boolean(is_super || is_admin)}
            />
            {isCreate && (
                <RejectionReasonsCard
                    isChanged={isChanged}
                    setIsChanged={setIsChanged}
                    editData={editData}
                    setEditData={setEditData}
                />
            )}
            <RejectionReasonsTable
                isChanged={isChanged}
                setIsChanged={setIsChanged}
                handleEdit={handleEdit}
            />
        </>
    );
};
export default RejectionReasons;
